<template>
  <v-container fluid class="questionario-shell">
    <v-card class="mt-6 questionario-card" elevation="2">
      <v-card-title class="font-weight-bold d-flex align-center">
        <v-btn
          outlined
          color="grey lighten-1"
          class="mr-4"
          @click="voltarConfigurarQuestionario"
          title="Voltar para configuração de questionário"
        >
          <v-icon size="20">mdi-arrow-left</v-icon>
          <span class="ml-2" style="font-size: 10px">Voltar</span>
        </v-btn>
        Editar Questionário
      </v-card-title>

      <v-card-text>
        <template v-if="questionarioSelecionado">
          <p><strong>ID:</strong> {{ questionarioSelecionado.id }}</p>
        </template>

        <v-select
          v-model="idInstrumento"
          :items="listaInstrumentos"
          item-text="descricao"
          item-value="id"
          label="Instrumento"
          readonly
          outlined
          class="mb-3"
        ></v-select>

        <v-text-field v-model="anexo" label="Anexo" outlined class="mb-3"></v-text-field>
        <v-text-field v-model="ano" readonly label="Ano" type="number" outlined class="mb-3"></v-text-field>

        <v-select v-model="statusSelecionado" :items="statusOptions" label="Status" outlined class="mb-3"></v-select>

        <v-select
          v-model="idPublicoSelecionado"
          :items="publicosOptions"
          item-text="descricao"
          item-value="id"
          label="Público"
          outlined
          class="mb-3"
          :loading="loadingPublicos"
        ></v-select>

        <v-text-field
          v-model="grupoResposta"
          label="Grupo Resposta"
          type="number"
          outlined
          class="mb-3"
          append-icon="mdi-magnify"
          @click="abrirModalGrupos"
          @click:append="abrirModalGrupos"
          readonly
        ></v-text-field>

        <v-btn
          v-if="questionarioSelecionado && questionarioSelecionado.id"
          color="success"
          class="mt-4 mx-2"
          style="min-width: 180px"
          @click="salvarEdicaoQuestionario"
          :disabled="!formValido"
          :block="$vuetify.breakpoint.smAndDown"
        >
          Salvar Alterações
        </v-btn>

        <v-btn
          v-else
          color="success"
          class="mt-4 mx-2"
          style="min-width: 180px"
          @click="salvarNovoQuestionario"
          :disabled="!formValido"
          :block="$vuetify.breakpoint.smAndDown"
        >
          Criar Questionário
        </v-btn>

        <v-btn
          v-if="questionarioSelecionado && questionarioSelecionado.id"
          color="error"
          class="mt-2 mx-2"
          style="min-width: 180px"
          @click="excluirQuestionario"
          :block="$vuetify.breakpoint.smAndDown"
        >
          Excluir Questionário
        </v-btn>
        <v-btn
          v-if="questionarioSelecionado && questionarioSelecionado.id"
          color="primary"
          class="mt-2 mx-2"
          style="min-width: 180px"
          @click="editarQuestoes"
          :block="$vuetify.breakpoint.smAndDown"
        >
          Questões
        </v-btn>
      </v-card-text>

      <v-dialog v-model="modalGrupos" max-width="600px">
        <v-card>
          <v-card-title class="headline">Selecione o Grupo de Resposta</v-card-title>
          <v-card-text>
            <div v-if="loadingGrupos" class="text-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <div v-else>
              <v-row>
                <v-col v-for="(grupo, idx) in gruposOpcoes" :key="idx" cols="12" md="6">
                  <v-card outlined @click="selecionarGrupo(grupo.grupo)" class="mb-2" style="cursor: pointer">
                    <v-card-title>Grupo {{ grupo.grupo }}</v-card-title>
                    <v-card-text>
                      <v-list dense>
                        <v-list-item v-for="opcao in grupo.opcoes" :key="opcao.ordem">
                          <v-list-item-content>
                            <v-list-item-title>{{ opcao.descricao }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <span class="grey--text">Valor: {{ opcao.valor }}</span>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalGrupos = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="loading" persistent max-width="300">
        <v-card color="primary" dark>
          <v-card-text class="text-center">
            <v-progress-circular indeterminate color="white"></v-progress-circular>
            <div class="mt-3">Processando...</div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3500" top>
        {{ snackbarText }}
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import InstrumentoQuestionarioServices from "@/services/rh/InstrumentoQuestionarioServices";
export default {
  name: "EditarQuestionarioForm",
  computed: {
    ...mapGetters({
      questionarioSelecionado: "avaliacao/selecionado",
      listaInstrumentos: "avaliacao/getListaInstrumentos",
      instrumentoSelecionado: "avaliacao/getInstrumentoSelecionado",
      anoSelecionado: "avaliacao/anoSelecionado",
    }),
    formValido() {
      const q = this.questionarioSelecionado || {};
      const preenchido = (val) => val !== null && val !== undefined && String(val).trim() !== "";
      return (
        preenchido(q.id_instrumento) &&
        preenchido(q.anexo) &&
        preenchido(q.ano) &&
        preenchido(q.status) &&
        preenchido(q.id_publico) &&
        preenchido(q.grupo_resposta)
      );
    },
    idInstrumentoSelecionado() {
      return this.instrumentoSelecionado?.id || this.questionarioSelecionado?.id_instrumento || null;
    },
    id_formulario: {
      get() {
        return this.questionarioSelecionado?.id || null;
      },
      set(val) {
        this.setSelecionado({ ...this.questionarioSelecionado, id: val });
      },
    },
    idInstrumento: {
      get() {
        return this.questionarioSelecionado?.id_instrumento || null;
      },
      set(val) {
        const instrumento = this.listaInstrumentos.find((item) => Number(item.id) === Number(val));
        this.setSelecionado({
          ...this.questionarioSelecionado,
          id_instrumento: val,
          instrumento: instrumento ? instrumento.descricao : this.questionarioSelecionado.instrumento || "",
        });
      },
    },
    anexo: {
      get() {
        return this.questionarioSelecionado?.anexo || "";
      },
      set(val) {
        this.setSelecionado({ ...this.questionarioSelecionado, anexo: val });
      },
    },
    ano: {
      get() {
        return this.questionarioSelecionado?.ano || "";
      },
      set(val) {
        this.setSelecionado({ ...this.questionarioSelecionado, ano: val });
      },
    },
    statusSelecionado: {
      get() {
        return this.questionarioSelecionado?.status !== undefined && this.questionarioSelecionado?.status !== null
          ? Number(this.questionarioSelecionado.status)
          : 0;
      },
      set(val) {
        this.setSelecionado({ ...this.questionarioSelecionado, status: val });
      },
    },
    idPublicoSelecionado: {
      get() {
        return this.questionarioSelecionado?.id_publico !== undefined &&
          this.questionarioSelecionado?.id_publico !== null
          ? Number(this.questionarioSelecionado.id_publico)
          : null;
      },
      set(val) {
        this.setSelecionado({ ...this.questionarioSelecionado, id_publico: val });
      },
    },
    grupoResposta: {
      get() {
        return this.questionarioSelecionado?.grupo_resposta || "";
      },
      set(val) {
        this.setSelecionado({ ...this.questionarioSelecionado, grupo_resposta: val });
      },
    },
  },
  data() {
    return {
      statusOptions: [
        { text: "----", value: null },
        { text: "Sim", value: 1 },
        { text: "Não", value: 0 },
      ],
      publicosOptions: [],
      loadingPublicos: false,
      modalGrupos: false,
      loadingGrupos: false,
      gruposOpcoes: [],
      loading: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  methods: {
    ...mapActions({
      requestPublicoQuestionarioAll: "avaliacao/requestPublicoQuestionarioAll",
      requestOpcoes: "avaliacao/requestOpcoes",
      atualizarQuestionario: "avaliacao/atualizarQuestionario",
      criarQuestionario: "avaliacao/criarQuestionario",
      deletarQuestionario: "avaliacao/deletarQuestionario",
    }),
    ...mapMutations({
      setAnoSelecionado: "avaliacao/setAnoSelecionado",
      setSelecionado: "avaliacao/setSelecionado",
    }),
    voltarConfigurarQuestionario() {
      this.setSelecionado(this.questionarioSelecionado);

      this.$router.push({ name: "ConfigurarQuestionario" });
    },
    async carregarPublicos() {
      this.loadingPublicos = true;
      try {
        const { data } = await this.requestPublicoQuestionarioAll();
        this.publicosOptions = Array.isArray(data) ? data.map((p) => ({ ...p, id: Number(p.id) })) : [];
      } catch (e) {
        this.publicosOptions = [];
      }
      this.loadingPublicos = false;
    },
    async abrirModalGrupos() {
      this.modalGrupos = true;
      this.loadingGrupos = true;
      try {
        const resp = await this.requestOpcoes({});
        const data = resp.data || [];
        const grupos = {};
        data.forEach((op) => {
          if (!grupos[op.grupo]) grupos[op.grupo] = [];
          grupos[op.grupo].push(op);
        });
        this.gruposOpcoes = Object.keys(grupos).map((grupo) => ({
          grupo,
          opcoes: grupos[grupo],
        }));
      } catch (e) {
        this.gruposOpcoes = [];
      }
      this.loadingGrupos = false;
    },
    selecionarGrupo(grupo) {
      this.grupoResposta = grupo;
      this.modalGrupos = false;
    },
    async salvarNovoQuestionario() {
      this.salvarQuestionarioPorTipo("novo");
    },
    async salvarEdicaoQuestionario() {
      return this.salvarQuestionarioPorTipo("edicao");
    },
    async atualizarQuestionarios() {
      await InstrumentoQuestionarioServices.loadQuestionariosInstrumento(
        this.anoSelecionado,
        this.idInstrumentoSelecionado,
      );
    },
    async salvarQuestionarioPorTipo(tipo) {
      this.loading = true;
      const payload = { ...this.questionarioSelecionado };
      try {
        if (tipo === "edicao") {
          console.log("editar.....", payload);
          const { data } = await this.atualizarQuestionario(payload);
          if (data.success) {
            this.setSelecionado(data.data);
            this.snackbarText = "Questionário atualizado com sucesso!";
            this.snackbarColor = "success";
          } else {
            this.snackbarText = "Erro ao criar questionário: " + (data.message || "Resposta inesperada do servidor");
            this.snackbarColor = "error";
          }
        } else {
          const { data } = await this.criarQuestionario(payload);
          if (data.success) {
            this.id_formulario = data.data.id; // Atualiza o ID do questionário criado
            this.snackbarText = "Questionário criado com sucesso!";
            this.snackbarColor = "success";
          } else {
            this.snackbarText = "Erro ao criar questionário: " + (data.message || "Resposta inesperada do servidor");
            this.snackbarColor = "error";
          }
        }
      } catch (e) {
        console.error("Erro ao salvar questionário:", e);
        this.snackbarText = "Erro ao salvar questionário";
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.loading = false;
    },
    async excluirQuestionario() {
      if (!this.questionarioSelecionado || !this.questionarioSelecionado.id) return;
      this.loading = true;
      try {
        await this.deletarQuestionario(this.questionarioSelecionado.id);
        this.snackbarText = "Questionário excluído com sucesso!";
        this.snackbarColor = "success";
      } catch (e) {
        this.snackbarText = "Erro ao excluir questionário";
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.loading = false;
    },
    editarQuestoes() {
      this.setSelecionado(this.questionarioSelecionado);
      this.$router.push({ name: "EditorQuestoes" });
    },
  },
  mounted() {
    this.carregarPublicos();
    if (!this.questionarioSelecionado || Object.keys(this.questionarioSelecionado).length === 0) {
      this.setSelecionado({
        id: null,
        id_instrumento: this.idInstrumentoSelecionado,
        instrumento: "",
        anexo: "",
        ano: this.anoSelecionado || "",
        status: 0,
        id_publico: null,
        grupo_resposta: "",
      });
    }
    if (this.idInstrumentoSelecionado) {
      this.idInstrumento = this.idInstrumentoSelecionado;
    }
    if (this.anoSelecionado !== null && this.anoSelecionado !== undefined) {
      this.ano = this.anoSelecionado;
    }
  },
  watch: {
    idInstrumentoSelecionado: function (newVal, oldVal) {
      oldVal;
      newVal;
      if (newVal !== null && newVal !== undefined) {
        this.idInstrumento = newVal;
      }
    },
  },
};
</script>

<style scoped>
.questionario-shell {
  width: 100%;
  padding: 24px;
}

.questionario-card {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .questionario-shell {
    padding: 12px;
  }
}
</style>
